export default async function auth({ next, store }) {
  if (!store.getters["auth/loggedIn"]) {
    return next({ name: "Login" });
  }

  try {
    if (!store.state.profile.permisos) {
      await store.dispatch("profile/getPermisos");
    }
  } catch (error) {
    if (error?.response?.status === 401) {
      try {
        await store.dispatch("auth/logout");
      } catch (logoutError) {
        // La sesión local se limpia aunque el token ya no sea válido.
      }
      return next({ name: "Login" });
    }
    return next(error);
  }

  return next();
}
